export default __webpack_public_path__ + "static/media/edit_24dp.0d620566.svg";